import { ISuggestion } from '../model/event.model';
export class CitationRefModel {
  citationId: string;
  about: string;
  resource: string;
  citationString: string;
  editable: boolean;
  referencedBy: any[];
  rel?: string;
  constructor(
    id: string,
    citationString: string,
    editable: boolean,
    resource?: string,
    about?: string,
    referencedBy?: [],
    rel?: string
  ) {
    this.citationId = id;
    this.citationString = citationString;
    this.editable = editable;
    this.resource = resource ? resource : undefined;
    this.about = about ? about : undefined;
    this.referencedBy = referencedBy;
    this.rel = rel ? rel : null;
  }
}

export class CitationUnnumberedRefModel {
  citationId: string;
  citationString: string;
  editable: boolean;
  guidbr?: string;

  constructor(
    citationId: string,
    citationString: string,
    editable: boolean,
    guidbr?: string
  ) {
    this.citationId = citationId;
    this.citationString = citationString;
    this.editable = editable;
    this.guidbr = guidbr;
  }
}

export class CitationObjectModel {
  references: CitationRefModel[];
  unnumbered_references: CitationUnnumberedRefModel[];

  constructor(
    references?: CitationRefModel[],
    unnumbered_references?: CitationUnnumberedRefModel[]
  ) {
    this.references = references ? references : null;
    this.unnumbered_references = unnumbered_references
      ? unnumbered_references
      : null;
  }
}

export class CitationPostAPIRequestModel {
  content: string;
  citations: CitationObjectModel;
  suggestions: Object[];

  constructor(
    content: string,
    citations: CitationObjectModel,
    suggestions?: Object[]
  ) {
    this.content = content;
    this.citations = citations;
    this.suggestions = suggestions;
  }
}

export class CitationReferenceDocumentModel {
  id: string;
  constructor(id: string) {
    this.id = id;
  }
}

export class CitationRefAdditionalAttributes {
  resource?: string;
  about?: string;

  constructor(resource?: string, about?: string) {
    this.resource = resource;
    this.about = about;
  }
}

export class CitationCopyRefModel {
  id: string;
  count: string;

  constructor(id: string, count: string) {
    this.id = id;
    this.count = count;
  }
}

export interface ChevronNavDataModel {
  id: string;
  navDirection: string;
}

export interface CitationData {
  citationId: string;
  citationCount: string;
  isFirstCitedCitation: boolean;
  isDeleted: boolean;
}

export interface CitationDeleteDialogData {
  item?: Element;
  referencedBy: string[];
  suggestion?: ISuggestion;
  subTempWithUnTrackedFirstCitedCitation?: boolean;
}

export enum NavDirection {
  RIGHT = 'right',
  LEFT = 'left',
}

export interface Marker {
  name: string;
}

export interface Callback {
  data: any;
  callback: Function;
}

export interface FirstCitedCitationsDeleted {
  removeSubCallBackAndData: Callback;
  suggestion: ISuggestion;
}
